export default "__VITE_ASSET__BSx_2Ojc__"